import type React from "react";
import { Col } from "./col";

type Props = {
	children: React.ReactNode;
};

export const Grid = ({ children }: Props) => (
	<div className="w-full">
		{/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
		<div className="-mx-2 flex w-full flex-row flex-wrap overflow-x-hidden">{children}</div>
	</div>
);

Grid.Col = Col;
